/* eslint-disable max-classes-per-file */
import { IDagKvantitet } from "~app/common/models/dagkvantitet";
import { ForsorjningskallaAggregat, ForsorjningskallaTyp } from "~app/common/models/forsorjningskalla";
import { ICommand } from "~app/common/services/cqs/command.service";
import { CommandBase } from "../../../../common/services/cqs/commandManager";

export class SetForsorjningsradPlanProduktionsomradeCommand extends CommandBase {
    kundorderradId: number;
    produktionsomradeId: number;
    periodStart: Date;
    periodEnd: Date;
    fordeladKvantitet: IDagKvantitet[];

    constructor(init: (instance: SetForsorjningsradPlanProduktionsomradeCommand) => void) {
        super("SetForsorjningsradPlanProduktionsomradeCommand");
        init(this);
    }
}

export class SetForsorjningsradPlanTerminalCommand extends CommandBase {
    kundorderradId: number;
    mottagningsplatsId: number;
    periodStart: Date;
    periodEnd: Date;
    fordeladKvantitet: IDagKvantitet[];

    constructor(init: (instance: SetForsorjningsradPlanTerminalCommand) => void) {
        super("SetForsorjningsradPlanTerminalCommand");
        init(this);
    }
}

export class SetForsorjningsradPlanLevorderCommand extends CommandBase {
    kundorderradId: number;
    leverantorsorderradId: number;
    periodStart: Date;
    periodEnd: Date;
    fordeladKvantitet: IDagKvantitet[];

    constructor(init: (instance: SetForsorjningsradPlanLevorderCommand) => void) {
        super("SetForsorjningsradPlanLevorderCommand");
        init(this);
    }
}

export class SetForsorjningsradPlanCommandFactory {

    static createSetForsorjningsradPlanCommand(
        model: ForsorjningskallaAggregat,
        kundorderradId: number,
        periodStart: Date,
        periodEnd: Date,
        fordeladKvantitet: IDagKvantitet[]): ICommand {
        switch (model.typ) {
            case ForsorjningskallaTyp.Produktionsomrade:
                return new SetForsorjningsradPlanProduktionsomradeCommand(c => {
                    c.kundorderradId = kundorderradId;
                    c.produktionsomradeId = model.id;
                    c.periodStart = periodStart;
                    c.periodEnd = periodEnd;
                    c.fordeladKvantitet = fordeladKvantitet;
                });
            case ForsorjningskallaTyp.Terminal:
                return new SetForsorjningsradPlanTerminalCommand(c => {
                    c.kundorderradId = kundorderradId;
                    c.mottagningsplatsId = model.id;
                    c.periodStart = periodStart;
                    c.periodEnd = periodEnd;
                    c.fordeladKvantitet = fordeladKvantitet;
                });
            case ForsorjningskallaTyp.Leverantorsorder:
                return new SetForsorjningsradPlanLevorderCommand(c => {
                    c.kundorderradId = kundorderradId;
                    c.leverantorsorderradId = model.id;
                    c.periodStart = periodStart;
                    c.periodEnd = periodEnd;
                    c.fordeladKvantitet = fordeladKvantitet;
                });
            default:
                throw new Error(`Odefinierad typ: ${model.typ}`);
        }
    }
}
